import { useState } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { profileService } from "../services";
// import { useAuth } from "../contexts/AuthContext";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

const schema = yup.object().shape({
  password: yup
    .string()
    .required("New password is required")
    .min(8, "Password must be at least 8 characters")
    .matches(/^[^\s]+$/, "Password must not contain spaces")
    .matches(/[A-Z]/, "Must contain at least one uppercase letter")
    .matches(/[a-z]/, "Must contain at least one lowercase letter")
    .matches(/[0-9]/, "Must contain at least one number")
    .matches(
      /[!@#$%^&*]/,
      "Must contain at least one special character (!@#$%^&*)"
    ),
  confirmPassword: yup
    .string()
    .required("Please confirm your new password")
    .oneOf(
      [yup.ref("password")],
      "New password and confirm password do not match"
    ),
});

const UpdatePassword = ({ userId }) => {
  const { loginPassword } = useAuth();
  const { logout } = useAuth();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    const payload = {
      userId,
      oldPassword: loginPassword,
      newPassword: data.password,
    };

    try {
      setLoading(true);
      const response = await profileService.passwordUpdate(payload);

      if (response.success) {
        toast.success("Password updated successfully!");
        reset();
        setTimeout(() => {
          logout();
          navigate("/");
        }, 1000);
      } else {
        toast.error(response.message || "Failed to update password.");
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)} className="UpdatePassword">
      <h3>Password Update</h3>
      <Row>
        <Col md={6}>
          <Form.Group>
            <Form.Label>New Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Enter it here"
              {...register("password")}
              isInvalid={!!errors.password}
            />
            {errors.password && (
              <div className="text-danger">{errors.password.message}</div>
            )}
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group>
            <Form.Label>Confirm Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Enter it here"
              {...register("confirmPassword")}
              isInvalid={!!errors.confirmPassword}
            />
            {errors.confirmPassword && (
              <div className="text-danger">
                {errors.confirmPassword.message}
              </div>
            )}
          </Form.Group>
        </Col>
      </Row>

      <div className="profile-all-click-bt">
        <Button
          variant="primary"
          type="submit"
          className="mt-3"
          disabled={loading || isSubmitting}
        >
          {loading ? "Updating..." : "Update Password"}
        </Button>
      </div>
    </Form>
  );
};

export default UpdatePassword;
